import React from 'react';
import { Spinner } from 'react-bootstrap';
import CancelButton from './Buttons/CancelButton';
import PrimaryButton from './Buttons/PrimaryButton';
import './PageHeader.css';

const PageHeader = ({
  icon,
  title,
  description,
  hideDescriptionOnMobile = false,
  hideMobile = false,
  cancelButton = null,
  secondaryButton = null,
  saveButton = null,
  fullscreenButton = null,
  className = ''
}) => {
  return (
    <div className={`page-header ${hideMobile ? 'd-none d-md-block' : ''} ${className}`}>
      <div className="header-content">
        <div className="header-content-left">
          {icon && (
            <div className="header-icon">
              {icon}
            </div>
          )}
          <div className="header-text">
            <h4 className="header-title">{title}</h4>
            {description && (
              <p className={`header-description ${hideDescriptionOnMobile ? 'd-none d-md-block' : ''}`}>
                {description}
              </p>
            )}
          </div>
        </div>

        {(cancelButton || secondaryButton || saveButton || fullscreenButton) && (
          <div className={`header-actions ${(secondaryButton?.hideMobile && !cancelButton && !saveButton && !fullscreenButton) ? 'd-none d-md-flex' : ''}`}>
            {cancelButton && (
              <CancelButton
                onClick={cancelButton.onClick}
                disabled={cancelButton.disabled}
                className={`header-action-btn ${cancelButton.className || ''}`}
                style={cancelButton.style}
              >
                {cancelButton.loading ? (
                  <>
                    <Spinner
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                      className="me-2"
                    />
                    {cancelButton.loadingText || cancelButton.children}
                  </>
                ) : (
                  cancelButton.children
                )}
              </CancelButton>
            )}

            {secondaryButton && (
              <button
                onClick={secondaryButton.onClick}
                disabled={secondaryButton.disabled}
                className={`btn header-action-btn header-secondary-btn ${secondaryButton.className || ''}`}
                style={secondaryButton.style}
                type={secondaryButton.type}
              >
                {secondaryButton.loading ? (
                  <>
                    <Spinner
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                      className="me-2"
                    />
                    {secondaryButton.loadingText || secondaryButton.children}
                  </>
                ) : (
                  secondaryButton.children
                )}
              </button>
            )}

            {saveButton && (
              <div className={`save-button-wrapper ${saveButton.creditText ? 'has-credit-text' : ''}`}>
                <PrimaryButton
                  onClick={saveButton.onClick}
                  disabled={saveButton.disabled}
                  className={`header-action-btn ${saveButton.className || ''}`}
                  style={saveButton.style}
                  type={saveButton.type}
                  form={saveButton.form}
                  backgroundColor={saveButton.backgroundColor}
                  borderColor={saveButton.borderColor}
                  color={saveButton.color}
                  hoverBackgroundColor={saveButton.hoverBackgroundColor}
                  hoverBorderColor={saveButton.hoverBorderColor}
                  hoverColor={saveButton.hoverColor}
                  hoverBoxShadow={saveButton.hoverBoxShadow}
                  hoverTransform={saveButton.hoverTransform}
                >
                  {saveButton.loading ? (
                    <>
                      <Spinner
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                        className="me-2"
                      />
                      {saveButton.loadingText || saveButton.children}
                    </>
                  ) : (
                    saveButton.children
                  )}
                </PrimaryButton>
                {saveButton.creditText && (
                  <div className="button-credit-text">{saveButton.creditText}</div>
                )}
              </div>
            )}

            {fullscreenButton && (
              <button
                onClick={fullscreenButton.onClick}
                disabled={fullscreenButton.disabled}
                className={`btn btn-outline-secondary fullscreen-button ${fullscreenButton.className || ''}`}
                style={fullscreenButton.style}
                title={fullscreenButton.title}
              >
                {fullscreenButton.icon}
                {fullscreenButton.children && (
                  <span className="ms-2 d-lg-inline">{fullscreenButton.children}</span>
                )}
              </button>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default PageHeader;